import API from "../../utils/api";
import {FETCHED_FORMS, FETCHED_KEYWORDS, FETCHED_LAW_TERMS} from "../constants";
import {localStorageAccessTokenKey} from "../../utils/constants";

export const getForms = () => async(dispatch: any) => {
    const token = localStorage.getItem(localStorageAccessTokenKey);
    try {
        const response = await API.get("forms/names", {
            headers: {"Authorization": "Bearer " + token}
        });
        dispatch({ type: FETCHED_FORMS, payload: response.data });
        return response;
    } catch (err) {
        return err;
    }
};

export const downloadForm = (name: any) => async(dispatch: any) => {
    const token = localStorage.getItem(localStorageAccessTokenKey);
    try {
        const response = await API.get("forms?" + name, {
            headers: {"Authorization": "Bearer " + token}
        });
        return response;
    } catch (err) {
        return err;
    }
};
